export const formSubmmitMapper = (data) => ({
  id_sumber_pengadaan: data?.idSumberPengadaan,
  nama_sumber_pengadaan: data?.namaSumberPengadaan,
  keterangan: data?.keterangan,
});
